import { render } from "./ErrorInfo.vue?vue&type=template&id=84da0610&scoped=true&lang=html"
import script from "./ErrorInfo.vue?vue&type=script&lang=js"
export * from "./ErrorInfo.vue?vue&type=script&lang=js"

import "./ErrorInfo.vue?vue&type=style&index=0&id=84da0610&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-84da0610"

export default script